import { BpmnProcessActions, BpmnProcessActionTypes } from '../actions';
import { initialState } from '../state';

export function processInstanceId(state = initialState.processInstanceId, action: BpmnProcessActions): string {
  switch (action.type) {
    case BpmnProcessActionTypes.UPDATE_PROCESS_INSTANCE:
      return action.payload.processInstanceId;
    default: {
      return state;
    }
  }
}
